export default __webpack_public_path__ + "static/alignerbase-full-banner-video-7980a19587737e22576f511988f5e630.mp4";